import getHelper from '../../../services/getHelper';

export default getHelper('/specific-statuses');
